import React from "react";

interface InputPlaceholderStylesProps {
  color: string;
}

// Neither a <select> nor a <button> has a ::placeholder, so Dropdown marks
// itself with .Dropdown-select-placeholder while nothing is chosen.
const selector =
  "input::placeholder, textarea::placeholder, .Dropdown-select-placeholder";

/**
 * Component that injects input placeholder style. These styles cannot
 * be applied as inline styles, so they're added as raw CSS in style tags.
 * The !important is required even though our inline styles do not apply
 * these rules.
 */
export const InputPlaceholderStyles: React.FC<InputPlaceholderStylesProps> = ({
  color,
}) => {
  return (
    <style>
      {`
        ${selector} {
          color:${color}!important;
        }
      `}
    </style>
  );
};
